<template>
  <div class="container h-full mx-auto">
    <div class="relative h-full bg-cover" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
      <PerfectScrollbar class="h-full">
        <slot />

        <BaseCopyright />
      </PerfectScrollbar>
    </div>
  </div>
</template>

<script>
import BaseCopyright from '@components/_base-copyright.vue'
export default {
  name: 'HomeLayout',
  components: { BaseCopyright },
  props: {
    backgroundImage: {
      type: String,
      required: false,
      default: require('@assets/images/bg-home.png'),
    },
  },
}
</script>
